import { templateToTitle } from '@apps/card/utils';
import { CardPdpSeoDataQuery, StationeryTemplateCategoryEnum, useCardPdpSeoDataQuery } from '@graphql/generated';
import { Seo } from '@shared/components/Seo';
import React, { useMemo } from 'react';
import { useTranslation } from '@shared/core';

type PdpSeoProps = {
  themeId: string;
  currentCategory: StationeryTemplateCategoryEnum;
};

type SeoContentProps = {
  data: CardPdpSeoDataQuery['stationeryTemplatesByThemeId'][0];
  currentCategory: StationeryTemplateCategoryEnum;
};

const SeoContent = ({ data, currentCategory }: SeoContentProps) => {
  const { tq } = useTranslation('stationery');
  const templateTitle = templateToTitle(data);

  const TEMPLATE_CATEGORY_TO_TITLE = useMemo(
    () => ({
      [StationeryTemplateCategoryEnum.saveTheDate]: tq`Shop the '${templateTitle}' Save the Date Card | Joy`,
      [StationeryTemplateCategoryEnum.invitation]: tq`Shop the '${templateTitle}' Invitation Card | Joy`,
      [StationeryTemplateCategoryEnum.thankYou]: tq`Shop the '${templateTitle}' Thank You Card | Joy`,
      [StationeryTemplateCategoryEnum.holiday]: tq`Shop the '${templateTitle}' Holiday Card | Joy`,
      [StationeryTemplateCategoryEnum.enclosure]: tq`Shop the '${templateTitle}' Enclosure Card | Joy`,
    }),
    [tq, templateTitle],
  );

  const title = (currentCategory in TEMPLATE_CATEGORY_TO_TITLE && TEMPLATE_CATEGORY_TO_TITLE[currentCategory as keyof typeof TEMPLATE_CATEGORY_TO_TITLE]) || '';
  const fallbackTitle = tq`Shop the '${templateTitle}' Card | Joy`;

  return (
    <Seo
      title={title || fallbackTitle}
      ogImage={data.thumbnailUrl || undefined}
    />
  );
};

export const PdpSeo = (props: PdpSeoProps) => {
  const { themeId, currentCategory } = props;
  const { data } = useCardPdpSeoDataQuery({ variables: { themeId, category: currentCategory }, batchMode: 'fast' });

  const templateData = data?.stationeryTemplatesByThemeId[0];

  return (
    <>
      {templateData && (
        <SeoContent
          data={templateData}
          currentCategory={currentCategory}
        />
      )}
    </>
  );
};
